var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('app-cells',[_c('h1',{staticClass:"title"},[_vm._v("List of transfers")])]),_c('app-tabs',{attrs:{"tabs":_vm.tabs}}),_c('transition',{attrs:{"name":"fade","mode":"out-in"}},[_c('router-view')],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }